var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.93436 0 0 4.93436 0 11C0 17.0656 4.93436 22 11 22C17.0656 22 22 17.0656 22 11C22 4.93436 17.0656 0 11 0ZM16.5752 8.66895L10.6168 14.6272C10.438 14.8059 10.2034 14.8959 9.96875 14.8959C9.7341 14.8959 9.49945 14.8059 9.32069 14.6272L6.34158 11.6481C5.98306 11.2897 5.98306 10.7103 6.34158 10.3519C6.69994 9.99342 7.27917 9.99342 7.6377 10.3519L9.96875 12.683L15.2791 7.37283C15.6374 7.01431 16.2167 7.01431 16.5752 7.37283C16.9335 7.73119 16.9335 8.31042 16.5752 8.66895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCircleCheck);
export default __webpack_public_path__ + "static/media/white-circle-check.d125ecb6.svg";
export { ForwardRef as ReactComponent };